export const isEmptyArr = (arr: unknown[] | null | undefined) => {
  if (!arr) return !arr;

  return arr?.length === 0;
};
